import { useTranslations } from 'next-intl';
import {
  WorkspaceRoleEnum,
  type WorkspaceRole,
} from '@mentimeter/http-clients';
import { useCallback } from 'react';

export const useGetRoleDisplayName = () => {
  const t = useTranslations('purchasing.manage_members.roles');

  return useCallback(
    (role: WorkspaceRole) => {
      switch (role) {
        case WorkspaceRoleEnum.ADMIN:
          return t('admin_role_label');
        case WorkspaceRoleEnum.OWNER:
          return t('owner_role_label');
        case WorkspaceRoleEnum.USER:
          return t('member_role_label');
        case WorkspaceRoleEnum.MEMBER_LITE:
          return t('member_lite_role_label');
        case WorkspaceRoleEnum.NON_MEMBER:
          return t('non_member_role_label');
        default:
          return '';
      }
    },
    [t],
  );
};
